import { api } from "../lib/api";

export const list = () => api.get("/prospects").then((r) => r.data);

// ACTA_COMMERCE_AGENDA_FAST_API_V1
export const agenda = () => api.get("/prospects/agenda").then((r) => r.data);
export const create = (payload) => api.post("/prospects", payload).then((r) => r.data);

export const resolveLocation = (address) =>
  api
    .post("/prospects/location/resolve", { address })
    .then((response) => response.data);
export const update = (id, payload) => api.put(`/prospects/${id}`, payload).then((r) => r.data);
export const deleteImpact = (id) =>
  api
    .get(`/prospects/${id}/delete-impact`)
    .then((response) => response.data);

export const remove = (id) =>
  api
    .delete(`/prospects/${id}`)
    .then((response) => response.data);

export const setStatus = (id, status) =>
  api.put(`/prospects/${id}/status`, { commercial_status: status }).then((r) => r.data);

export const updatePurchaseIntent = (id, purchaseIntent, note = "") =>
  api
    .patch(`/prospects/${id}/purchase-intent`, {
      purchase_intent: purchaseIntent,
      note,
    })
    .then((response) => response.data);

export const listNotes = (id) =>
  api.get(`/prospects/${id}/notes`).then((r) => r.data);

export const addNote = (id, payload) =>
  api.post(`/prospects/${id}/notes`, payload).then((r) => r.data);

// ACTA_PROSPECT_CALL_CHANNELS_V1
export const startCall = (
  id,
  channel,
  source = "prospect_profile"
) =>
  api
    .post(`/prospects/${id}/call-intents`, {
      channel,
      source,
    })
    .then((response) => response.data);

export const recordCallOutcome = (
  noteId,
  resultCode
) =>
  api
    .put(
      `/prospect-call-intents/${noteId}/outcome`,
      {
        result_code: resultCode,
      }
    )
    .then((response) => response.data);

// ACTA_MEETING_OUTCOME_API_V3
export const recordMeetingOutcome = (
  source,
  meetingId,
  payload
) =>
  api
    .put(
      `/agenda/meetings/${encodeURIComponent(
        source
      )}/${encodeURIComponent(
        meetingId
      )}/outcome`,
      payload
    )
    .then((response) => response.data);


// ACTA_PROSPECT_MEETING_UPDATE_API_V1
export const updateNote = (noteId, payload) =>
  api.put(`/prospect-notes/${noteId}`, payload).then((r) => r.data);

export const updateNoteContent = (noteId, content) =>
  api.patch(`/prospect-notes/${noteId}/content`, { content }).then((r) => r.data);

export const removeNote = (noteId) =>
  api.delete(`/prospect-notes/${noteId}`).then((r) => r.data);

// ACTA_AGENDA_FOLLOWUP_COMPLETE_API_V1
export const completeFollowup = (noteId) =>
  api
    .put(`/prospect-notes/${encodeURIComponent(noteId)}/followup-complete`)
    .then((r) => r.data);

export const completeAction = (noteId) =>
  api
    .put(`/prospect-notes/${encodeURIComponent(noteId)}/action-complete`)
    .then((r) => r.data);

export const activity = (id) =>
  api.get(`/prospects/${id}/activity`).then((r) => r.data);

// ACTA_ACTIVITY_USER_STATE_V1
export const updateActivityState = (
  prospectId,
  payload
) =>
  api
    .put(
      `/prospects/${prospectId}/activity-state`,
      payload
    )
    .then((response) => response.data);

export const shareDiscussions = (id) =>
  api.get(`/prospects/${id}/share-discussions`).then((r) => r.data);

export const replyToShare = (prospectId, shareId, payload) =>
  api.post(`/prospects/${prospectId}/shares/${shareId}/messages`, payload).then((r) => r.data);

export const createShareAppointment = (prospectId, shareId, payload) =>
  api.post(`/prospects/${prospectId}/shares/${shareId}/appointments`, payload).then((r) => r.data);

export const updateShareAppointment = (prospectId, shareId, appointmentId, payload) =>
  api.put(`/prospects/${prospectId}/shares/${shareId}/appointments/${appointmentId}`, payload).then((r) => r.data);

/**
 * Analyse les lignes CSV sans créer de prospect.
 */
export const analyzeImport = (payload) =>
  api
    .post("/prospects/import", {
      ...payload,
      preview: true,
    })
    .then((response) => response.data);


/**
 * Confirme l'import après prévisualisation.
 */
export const importCsv = (payload) =>
  api
    .post("/prospects/import", {
      ...payload,
      preview: false,
    })
    .then((response) => response.data);


/**
 * Alias temporaire conservé pour éviter une régression
 * dans un éventuel ancien appel frontend.
 */
export const importExcel = importCsv;

export const bulkDelete = (ids) =>
  api.post("/prospects/bulk-delete", { ids }).then((r) => r.data);


export const contactSummary = ({ assignedUserId = "" } = {}) =>
  api
    .get("/prospects/contact-summary", {
      params: {
        assigned_user_id: assignedUserId,
      },
    })
    .then((response) => response.data);

/**
 * Charge la liste paginée des prospects.
 *
 * Tous les filtres, le tri et le périmètre utilisateur
 * sont appliqués côté backend.
 */
export const paginated = ({
  page = 1,
  limit = 10,
  search = "",
  city = "",
  assignedUserId = "",
  commercialStatus = "",
  purchaseIntent = "",
  dateFilter = "all",
  sinceDate = "",
  sortBy = "createdAt",
  sortOrder = "desc",
  lifecycleStage = "prospect",
  view = "",
} = {}) =>
  api
    .get("/prospects/paginated", {
      params: {
        page,
        limit,
        search,
        city,
        assigned_user_id: assignedUserId,
        commercial_status: commercialStatus,
        purchase_intent: purchaseIntent,
        date_filter: dateFilter,
        since_date: sinceDate,
        sort_by: sortBy,
        sort_order: sortOrder,
        lifecycle_stage: lifecycleStage,
        view,
      },
    })
    .then((response) => response.data);

/**
 * Charge les villes et commerciaux disponibles pour
 * les filtres de la page Prospects V2.
 */
export const filterOptions = () =>
  api
    .get("/prospects/filter-options")
    .then((response) => response.data);


// acta_patch_notes_prospect_v1
export async function listProspectNotes(prospectId) {
  const { data } = await api.get(`/prospects/${prospectId}/notes`);
  return data;
}

export async function addProspectNote(prospectId, payload) {
  const body = typeof payload === "string" ? { note: payload } : payload;
  const { data } = await api.post(`/prospects/${prospectId}/notes`, body);
  return data;
}

export async function deleteProspectNote(noteId) {
  const { data } = await api.delete(`/prospect-notes/${noteId}`);
  return data;
}

// acta_patch_lot2_crm_ca_step1
export const updateCommercial = (id, payload) =>
  api.put(`/prospects/${id}/commercial`, payload).then((r) => r.data);

// acta_patch_lot2_clients_machine_catalog_v1
export const convertToClient = (id) =>
  api.post(`/prospects/${id}/convert-client`).then((r) => r.data);



// acta_pipeline_client_sales_v1
export const pipelineTransition = (id, payload) =>
  api.post(`/prospects/${id}/pipeline-transition`, payload).then((r) => r.data);

/*
 * ACTA_LIST_PROSPECTS_EXPORT_START
 * Utilisé par la création de devis pour afficher une liste déroulante
 * des prospects/clients rattachables au devis.
 */
export const listProspects = async (params = {}) => {
  const response = await api.get("/prospects", { params });
  return response.data;
};
// ACTA_LIST_PROSPECTS_EXPORT_END



export const listCommercialUsers = () =>
  api.get("/commercial/users").then((r) => r.data);

export const assignCommercial = (id, payload) =>
  api.put(`/prospects/${id}/assignment`, payload).then((r) => r.data);


export const listCollaborators = (prospectId) =>
  api
    .get(
      `/prospects/${encodeURIComponent(
        prospectId
      )}/collaborators`
    )
    .then((response) => response.data);

export const listCollaboratorCandidates = (
  prospectId
) =>
  api
    .get(
      `/prospects/${encodeURIComponent(
        prospectId
      )}/collaborator-candidates`
    )
    .then((response) => response.data);

export const updateCollaborators = (
  prospectId,
  collaboratorUserIds
) =>
  api
    .put(
      `/prospects/${encodeURIComponent(
        prospectId
      )}/collaborators`,
      {
        collaborator_user_ids:
          collaboratorUserIds,
      }
    )
    .then((response) => response.data);
